import * as cldrSegmentation from 'cldr-segmentation'

export default class Segmenter

  @words: (text, language, options = {}) ->
    if @intlSegmenterSupported()
      wordsIntl(text, language, options) # We prefer Intl.Segmenter: It's the JS standard and works for non-Latin words (Chinese, Japanese, etc.)
    else
      wordsLegacy(text, language)        # Fallback for old Firefox versions (+ some old mobile)

  @sentences: (text, language) ->
    #if @intlSegmenterSupported()
    #  sentencesIntl(text, language) # Standard segmenter from browser, don't manage suppressions (yet?)
    #else
    sentencesLegacy(text, language) # For now we prefer the legacy solution because it manages suppressions ("Hi Ms. Brololo" is not split)

  @intlSegmenterSupported: ->
    typeof(Intl) != 'undefined' && typeof(Intl.Segmenter) == 'function'

  # Returns something like this: ['Hello', ' ', 'everyone', ',', ' ', 'how', ' ', 'are', ' ', 'you', '?']
  wordsIntl = (text, language, options = {}) ->
    language  = undefined if !language.length # Intl.Segmenter doesn't accept empty string
    segmenter = options['intlSegmenter'] || new Intl.Segmenter(language, granularity: 'word')
    segments  = segmenter.segment(text)

    Array.from(segments).map((x) -> x.segment)

  # Returns something like this before splitSpaces: ['Comment ça va ? ', 'Moi ça va bien !']
  # And something like this after splitSpaces:      ['Comment ça va ?', ' ', 'Moi ça va bien !']
  sentencesIntl = (text, language) ->
    language  = undefined if !language.length # Intl.Segmenter doesn't accept empty string
    segmenter = new Intl.Segmenter(language, granularity: 'sentence')
    segments  = segmenter.segment(text)
    sentences = Array.from(segments).map((x) -> x.segment)

    splitSpaces(sentences)

  # Returns something like this: ['Hello', ' ', 'everyone', ',', ' ', 'how', ' ', 'are', ' ', 'you', '?']
  wordsLegacy = (text, language) ->
    suppressions = cldrSegmentation.suppressions[language] # https://github.com/camertron/cldr-segmentation.js/#sentence-segmentation
    cldrSegmentation.wordSplit(text, suppressions)

  # Returns something like this before splitSpaces: ['Comment ça va ? ', 'Moi ça va bien !']
  # And something like this after splitSpaces:      ['Comment ça va ?', ' ', 'Moi ça va bien !']
  sentencesLegacy = (text, language) ->
    suppressions = cldrSegmentation.suppressions[language]
    sentences    = cldrSegmentation.sentenceSplit(text, suppressions)

    splitSpaces(sentences)

  # Don't mix sentences with starting/ending spaces in same strings
  # split the extra spacings into own sentences (that will be ignored on the backend).
  # It's very useful for the backend cache, so it can ignores spacing and concentrate on pure text.
  splitSpaces = (sentences) ->
    newSentences = []

    for sentence in sentences
      results = sentence.match(/^(\s*)([\s\S]*?)(\s*)$/)

      newSentences.push(results[1]) if results[1] != '' # before spaces
      newSentences.push(results[2]) if results[2] != '' # text itself
      newSentences.push(results[3]) if results[3] != '' # after spaces

    ###
    # Commented because it only works with SourceA! (contentEditable)
    # And it doesn't seem to be necessary for sourceB to visually keep consistent lines?
    ###
    # # Remove all last empty sentences
    # if newSentences.length
    #   for i in [newSentences.length-1..0] # from last index to first
    #     if newSentences[i].trim() == ''
    #       newSentences.pop()
    #     else
    #       break

    newSentences

